import store from '~/store'

export default async(to, from, next) => {
    if (store.getters['auth/existeUsuario']){
        next()
    } else {
        next({ name: 'login.form.admin' })
    }
}
